module.exports = __webpack_public_path__ + "img/arrow-down.921f2537.svg";